import { render, staticRenderFns } from "./Admin_memMgmt_agt.vue?vue&type=template&id=23826fe7&"
import script from "./Admin_memMgmt_agt.vue?vue&type=script&lang=js&"
export * from "./Admin_memMgmt_agt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports